/**
 * @module
 * @format
 */

import {ARRAY, BOOLEAN, FLOAT, INTEGER, OBJECT, OPTIONAL, STRING} from '@acng/frontend-rubicon';
import {TRANSLATIONS} from '../lang.js';
import {FSK_LEVEL} from '../fsk.js';

/**
 * Validate abstract gallery data. Use in `Movie` and `PictureSet`.
 *
 * @see [Movie](../../moviePool/model/movie.js)
 * @see [PictureSet](../../picturePool/model/picture-set.js)
 */
export const GALLERY_DATA = /* @__PURE__ */ OBJECT({
  set_id: INTEGER,
  nickname: STRING,
  user_id: STRING,
  published: INTEGER,
  price: INTEGER,
  blocked: OPTIONAL(BOOLEAN),
  votes: INTEGER,
  rating: FLOAT,
  category_codes: ARRAY(STRING),
  image_fsk12: OPTIONAL(STRING),
  image_fsk16: OPTIONAL(STRING),
  image_fsk18: OPTIONAL(STRING),
  media_rating: OPTIONAL(FLOAT),
  media_rating_test: OPTIONAL(FLOAT),
  name: OPTIONAL(TRANSLATIONS),
  description: OPTIONAL(TRANSLATIONS),
  fsk: FSK_LEVEL,
});
